import { BaseModel } from './base';

export class Tax extends BaseModel {
  idTax!: number;
  name!: string;
  amount!: number;

  override objectID(): string | null {
    return this.idTax?.toString() ?? null;
  }
}
